import {getDataContentful} from '../../services/contentful/index';

import {
    CLEAR_CONTENT,
    GET_PAGES_ERROR,
    GET_PAGES_INIT,
    GET_PAGES_SUCCESS,
    GET_PERSONALITY_ERROR,
    GET_PERSONALITY_INIT,
    GET_PERSONALITY_SUCCESS,
    GET_PERSONALITY_V2_ERROR,
    GET_PERSONALITY_V2_INIT,
    GET_PERSONALITY_V2_SUCCESS,
    GET_PERSONALITY_RESULT_ERROR,
    GET_PERSONALITY_RESULT_INIT,
    GET_PERSONALITY_RESULT_SUCCESS,
    GET_DEV_TALK_AGENDA_INIT,
    GET_DEV_TALK_AGENDA_ERROR,
    GET_DEV_TALK_AGENDA_SUCCESS,
    GET_DEV_TALK_PREPARATION_ERROR,
    GET_DEV_TALK_PREPARATION_SUCCESS,
    GET_DEV_TALK_PREPARATION_INIT,
    GET_BUSINESS_PROFILE_DESCRIPTION_INIT,
    GET_BUSINESS_PROFILE_DESCRIPTION_SUCCESS,
    GET_BUSINESS_PROFILE_DESCRIPTION_ERROR,
    GET_BUSINESS_PROFILE_FLEXIBILITY_INIT,
    GET_BUSINESS_PROFILE_FLEXIBILITY_SUCCESS,
    GET_BUSINESS_PROFILE_FLEXIBILITY_ERROR,
    GET_CONTENT_TYPE_INIT,
    GET_CONTENT_TYPE_ERROR,
    GET_CONTENT_TYPE_SUCCESS,
    GET_PERSONALITY_IRT_FACET_CONTENT_INIT,
    GET_PERSONALITY_IRT_FACET_CONTENT_SUCCESS,
    GET_PERSONALITY_IRT_FACET_CONTENT_ERROR,
    GET_BUSINESS_PROFILE_DIMENSIONS_INIT,
    GET_BUSINESS_PROFILE_DIMENSIONS_SUCCESS,
    GET_BUSINESS_PROFILE_DIMENSIONS_ERROR,
    GET_LOGIC_TEST_RESULT_CONTENT_INIT,
    GET_LOGIC_TEST_RESULT_CONTENT_SUCCESS,
    GET_LOGIC_TEST_RESULT_CONTENT_ERROR,
    GET_AGREEMENT_ERROR,
    GET_AGREEMENT_SUCCESS,
    GET_AGREEMENT_INIT,
    GET_CONSENT_ERROR,
    GET_CONSENT_SUCCESS,
    GET_CONSENT_INIT,
    GET_LOGIC_REPORT_SCORE_INIT,
    GET_LOGIC_REPORT_SCORE_SUCCESS,
    GET_LOGIC_REPORT_SCORE_ERROR
} from './constants';


export function clearContent() {
    return (dispatch) => {
        dispatch({type: CLEAR_CONTENT});
    };
}


export function getPersonalityResultContent() {
    const contentType = 'personalityResult';

    return (dispatch) => {
        dispatch({type: GET_PERSONALITY_RESULT_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_PERSONALITY_RESULT_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_PERSONALITY_RESULT_ERROR, error: 'Error fetching data'});
        });
    };
}


export function getPersonalityContent() {
    // See Contentful for names
    const contentType = 'personalityFactor';

    return (dispatch) => {
        dispatch({type: GET_PERSONALITY_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_PERSONALITY_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_PERSONALITY_ERROR, error: 'Error fetching data'});
        });
    };
}


export function getPersonalityContentV2() {
    // See Contentful for names
    let contentType = 'personalityFactorV2';

    return (dispatch) => {
        dispatch({type: GET_PERSONALITY_V2_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_PERSONALITY_V2_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_PERSONALITY_V2_ERROR, error: 'Error fetching data'});
        });
    };
}


export function getPagesContent() {
    let contentType = 'page';

    return (dispatch) => {
        dispatch({type: GET_PAGES_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_PAGES_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_PAGES_ERROR, error: 'Error fetching data'});
        });
    };
}

export function getAgreementContent() {
    let contentType = 'agreement';

    return (dispatch) => {
        dispatch({type: GET_AGREEMENT_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_AGREEMENT_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_AGREEMENT_ERROR, error: 'Error fetching data'});
        });
    };
}

export function getConsentContent() {
    let contentType = 'consent';

    return (dispatch) => {
        dispatch({type: GET_CONSENT_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_CONSENT_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_CONSENT_ERROR, error: 'Error fetching data'});
        });
    };
}

export function getDevelopmentTalkAgenda() {
    const contentType = 'developmentTalkAgenda';

    return (dispatch) => {
        dispatch({type: GET_DEV_TALK_AGENDA_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_DEV_TALK_AGENDA_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_DEV_TALK_AGENDA_ERROR, error: 'Error fetching data'});
        });
    };
}


export function getDevelopmentTalkPreparation() {
    const contentType = 'developmentTalkPreparation';

    return (dispatch) => {
        dispatch({type: GET_DEV_TALK_PREPARATION_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_DEV_TALK_PREPARATION_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_DEV_TALK_PREPARATION_ERROR, error: 'Error fetching data'});
        });
    };
}


export function getBusinessProfileDescription() {
    const contentType = 'businessProfile';

    return (dispatch) => {
        dispatch({type: GET_BUSINESS_PROFILE_DESCRIPTION_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_BUSINESS_PROFILE_DESCRIPTION_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_BUSINESS_PROFILE_DESCRIPTION_ERROR, error: 'Error fetching data'});
        });
    };
}


export function getBusinessProfileDimensions() {
    const contentType = 'businessProfileDimension';

    return (dispatch) => {
        dispatch({type: GET_BUSINESS_PROFILE_DIMENSIONS_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_BUSINESS_PROFILE_DIMENSIONS_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_BUSINESS_PROFILE_DIMENSIONS_ERROR, error: 'Error fetching data'});
        });
    };
}


export function getBusinessProfileFlexibility() {
    const contentType = 'businessProfileFlexibility';

    return (dispatch) => {
        dispatch({type: GET_BUSINESS_PROFILE_FLEXIBILITY_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_BUSINESS_PROFILE_FLEXIBILITY_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_BUSINESS_PROFILE_FLEXIBILITY_ERROR, error: 'Error fetching data'});
        });
    };
}

export function getPersonalityIrtFacetContent() {
    const contentType = 'personalityIrtFacet';

    return (dispatch) => {
        dispatch({type: GET_PERSONALITY_IRT_FACET_CONTENT_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_PERSONALITY_IRT_FACET_CONTENT_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_PERSONALITY_IRT_FACET_CONTENT_ERROR, error});
        });
    };
}

export function getLogicTestResultContent() {
    const contentType = 'logicTestResult';

    return (dispatch) => {
        dispatch({type: GET_LOGIC_TEST_RESULT_CONTENT_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_LOGIC_TEST_RESULT_CONTENT_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_LOGIC_TEST_RESULT_CONTENT_ERROR, error});
        });
    };
}


export function getContentByContentType(contentType) {

    return (dispatch) => {
        dispatch({type: GET_CONTENT_TYPE_INIT, contentType});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_CONTENT_TYPE_SUCCESS, contentType, data});
        }).catch(error => {
            console.error(error);
            dispatch({type: GET_CONTENT_TYPE_ERROR, contentType, error});
        });
    };
}


export function getLogicReportScoreContent() {
    const contentType = 'logicReportScore';

    return (dispatch) => {
        dispatch({type: GET_LOGIC_REPORT_SCORE_INIT});

        return getDataContentful(contentType).then(data => {
            dispatch({type: GET_LOGIC_REPORT_SCORE_SUCCESS, data});
        }).catch(error => {
            console.log(error);
            dispatch({type: GET_LOGIC_REPORT_SCORE_ERROR, error: 'Error fetching data'});
        });
    };
}
